import type { Dispatch, SetStateAction } from 'react';
import type { CurveDisplaySettings } from './curveDisplaySettings';
import type { CurveSettings } from './curveSettings';

/*
    Колонки, которые "убраны" еще не существуют.
*/
export type TabletColumns =
    /*
        Сервисные работы на скважине (перфорация, изоляция)
        Возможные другие названия: perforation / isolation
    */
    | 'wellServices'
    /*
        Геологические объекты (Пласт)
        Возможные другие названия: stratum
    */
    | 'allGeoObjects'
    /*
       Все геологические объекты (Пласт,Литология/Насыщение,Гистограммы параметров,Эффективная толщина)
        Возможные другие названия: stratum
    */
    | 'geoObjects'
    /*
        Стратиграфия
    */
    | 'stratigraphy'
    /*
        Система (Стратиграфия)
    */
    | 'stratigraphy_system'
    /*
        Отдел (Стратиграфия)
    */
    | 'stratigraphy_department'
    /*
        Ярус (Стратиграфия)
    */
    | 'stratigraphy_tier'
    /*
        Надгоризионт (Стратиграфия)
    */
    | 'stratigraphy_overhorizon'
    /*
        Горизонт (Стратиграфия)
    */
    | 'stratigraphy_horizon'
    /*
        ИННК / ИГН
    */
    | 'innk'
    /*
        Тех. характеристики
    */
    | 'tech'
    /*
        Колонны (Тех. характеристики)
    */
    | 'tech_columns'
    /*
        Цементаж (Тех. характеристики)
    */
    | 'tech_cement'
    /*
        Цем. мосты (Тех. характеристики)
    */
    | 'tech_bridges'
    /*
        Литология/Насыщение
    */
    | 'lithology'
    /*
        Характер насыщенности (Насыщенность)
        Возможные другие названия: saturation
    */
    // | 'fluidContent'
    /*
        Гистограммы параметров (Параметры)
    */
    | 'paramsHistogram'
    /*
        Цементометрия
        ! Сейчас это: РИГИС остаточной нефтенасыщенности
    */
    | 'cementBondLogging'
    /*
        Цементометрия НАСТОЯЩАЯ!
    */
    | 'cementometry'
    /*
        Каротаж
        Возможные другие названия: wellLogging / logging
    */
    | 'carrotage'
    /*
        ГРП
    */
    | 'sample'
    /*
        Керн
    */
    | 'core'
    /*
    Параметры керна
    */
    | 'coreParamsHistogram'
    /*
        Гидродинамические исследования
    */
    | 'fluidTest'
    /*
        Опробования пластов (Опробование)
    */
    | 'testing'
    /*
        Потокометрия
    */
    | 'flowmetry'
    /*
        Эффективная толщина
    */
    | 'thicknessInterlayer'
    /*
        Маркерные исследования
    */
    | 'tracers';
/*
        Пакеры
    */
// | 'packer'
/*
        Остаточная нефтенасыщенность
    */
// | 'residualSaturation'
/*
        ГСР
    */
// | 'gsr'
/*
        ГРП
    */
// | 'gdi'
/*
        ГРП
    */
// | 'grp'
/*
        Реперы
    */
// | 'rappers';

/*  !! Здесь нельзя использовать WellId
    потому что одна скважина может быть в нескольких списках с разными настройками
*/
type WellKey = string;
type ResearchKey = string;

export interface PayloadByWellKey<T> {
    readonly wellKey: WellKey;
    readonly data: T;
}

export enum WidthType {
    Auto = 'AUTO',
    Pixel = 'PIXEL',
    Percent = 'PERCENT',
}

export interface ColumnsSizingItem {
    width: number;
    minWidth: number;
    autoWidth: number;
    widthType: WidthType;
    singleColumnMinWidth?: number;
    [key: string]: { width: number } | number | WidthType | undefined;
}

export type ColumnsSizing = Record<TabletColumns, ColumnsSizingItem>;

export type ColumnsVisibility = Record<TabletColumns, boolean>;

export type HeaderSizes = {
    rigisColumnHeight: number;
    height: number;
    maxHeight: number;
    minHeight: number;
};

export interface TabletSettings {
    readonly wellLoggingKeys: string[];
    readonly curveSettings: Record<ResearchKey, CurveSettings>;
    readonly curveDisplaySettings: Record<ResearchKey, CurveDisplaySettings>;
    readonly rigisParamsHistogramIds: number[];
    readonly fgiParamsHistogramIds: number[];
    readonly coreKeys: number[];
    readonly headerSizes: HeaderSizes;
    readonly rigisColumnsCount: number;

    readonly columnsVisibility: ColumnsVisibility;
    readonly columnsSizing: ColumnsSizing;
    readonly columnsOrder: TabletColumns[];
    readonly rigisColumnsOrder: string[];
    // поле для оптимизации
    readonly prevTemplateId: string | number | null;
    readonly isKeysInit: boolean;
    readonly isFirstLoad?: boolean;
}

export type TabletSettingsState = Record<WellKey, TabletSettings>;

export interface TabletSettingsDispatch {
    setColumnVisibility: (payload: { wellKey: string; columnTitle: string }) => TabletSettingsState;
    setColumnSize: (payload: { wellKey?: number; columnTitle: string; columnSize: number }) => TabletSettingsState;
    setTabletSettings: (payload: PayloadByWellKey<Partial<TabletSettings>>) => TabletSettingsState;
    setBatchTabletSettings: (payload: Array<PayloadByWellKey<TabletSettings>>) => TabletSettingsState;
}

export interface SelectedWell {
    id: number;
    key: string;
    title: string;
}

export interface TabletSettingsContext {
    selectedWells: SelectedWell[] | null;
    tabletSettings: TabletSettings;
    tabletsSettings: Record<string, TabletSettings>;
    onSave: () => void;
    setSelectedWells: Dispatch<SetStateAction<SelectedWell[] | null>>;
    updateTabletSettings: (value: Partial<TabletSettings>) => void;
    showResearchSettings: () => void;
}

export interface TabletSettingsProviderProps {
    onClose: () => void;
}
